/**
 * "Kütüphaneye kaydet" — geçici bir personayı kalıcı kimliğe terfi ettirir.
 *
 * Kapatılan iş akışı boşluğu: sihirbaz bir soruya gerçekten iyi bir uzman
 * icat ediyor, tartışma bitiyor ve o kimlik yok oluyor. Kullanıcının onu
 * kaydetmek istediği AN, katkıyı okuduğu andır — bu yüzden düğme kütüphane
 * sayfasında değil, turun başlığında duruyor.
 *
 * Yalnızca kütüphane-dışı (wizard üretimi) konuşmacılarda görünür; zaten
 * kalıcı olan bir kimliği tekrar kaydetmek kopya üretirdi.
 */
import { useState } from "react";
import { BookmarkPlus, Check } from "lucide-react";
import {
  LibraryApiError,
  importPersonaFromDebate,
} from "../../transport/personaLibraryClient";

export function SaveToLibraryButton({
  speakerId,
  personaName,
}: {
  speakerId: string;
  personaName: string;
}) {
  const [state, setState] = useState<"idle" | "busy" | "done" | "error">("idle");
  const [message, setMessage] = useState<string | null>(null);

  if (state === "done") {
    return (
      <span
        className="inline-flex items-center gap-1 text-[10.5px] text-emerald-400"
        title="Persona kütüphaneye eklendi"
      >
        <Check className="h-3 w-3" aria-hidden />
        Kütüphanede
      </span>
    );
  }

  return (
    <button
      type="button"
      disabled={state === "busy"}
      title={
        message ??
        `${personaName} kimliğini kütüphaneye kaydet — sonraki tartışmalarda hafızasıyla birlikte kullanabilirsin`
      }
      onClick={async () => {
        setState("busy");
        setMessage(null);
        try {
          await importPersonaFromDebate(speakerId, personaName);
          setState("done");
        } catch (err) {
          setState("error");
          setMessage(
            err instanceof LibraryApiError ? err.message : "Kaydedilemedi.",
          );
        }
      }}
      className={[
        "inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[10.5px]",
        "transition-colors disabled:opacity-40",
        state === "error"
          ? "text-rose-400"
          : "text-fg-subtle hover:bg-surface-2/60 hover:text-accent-200",
      ].join(" ")}
    >
      <BookmarkPlus className="h-3 w-3" aria-hidden />
      {state === "busy" ? "Kaydediliyor…" : state === "error" ? "Hata" : "Kütüphaneye kaydet"}
    </button>
  );
}
